function removeExtraItems(data, limit, itemId) {
  const newData = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < data.length; i++) {
    if (data[i].id !== itemId) {
      newData.push(data[i]);
    }
    if (newData.length >= limit) break;
  }
  return newData;
}
export default removeExtraItems;
//# sourceMappingURL=remove-extra-items.js.map